import routes from '@/modules/document-series-type/document-series-type-routes';
import store from '@/modules/document-series-type/document-series-type-store';

export default {
    routes,
    store,
}
